import { inject } from "../../../../../../../common/container/inject";
import { ILearningRootService, LearningRootServiceToken } from "../../../../../service/LearningRootService";
import { IFullStudyReportDomain } from "./IFullStudyReportDomain";

export class FullStudyReportDomain implements IFullStudyReportDomain {
constructor(
    protected learningRootService = inject<ILearningRootService>(LearningRootServiceToken)
  ) {}
  downloadReport = (arg) => this.learningRootService.report.getUserLearningDataByProject(arg)
}